// extracted by mini-css-extract-plugin
export var dropdownContainer = "_p9-0";
export var leftAlign = "_p9-4";
export var listItem = "_p9-2";
export var listItemWrapper = "_p9-1";
export var operationText = "_p9-3";